import React, { useContext, useEffect, useState } from 'react'
import { Collapse, useTheme } from '@mui/material'
import AnnouncementIcon from '@mui/icons-material/Announcement'
import hipersendService from '../services/hipersend'
import { ApiDataWrapperContext } from '../contexts/ApiDataWrapper'
import { AuthContext } from '../contexts/Auth'
import Text from '../components/Text'
import Logo from '../components/Logo'
import NewVersionAppModal from '../components/NewVersionAppModal'
import SuspensaoOficialBanner from '../components/SuspensaoOficialBanner'
import LinearProgressCustom from '../components/LinearProgressCustom'
import TopNav from './TopNav'
import BottomNav, { ALTURA_BARRA_INFERIOR } from './BottomNav'

// A navegação vive no topo em qualquer largura. Acima de 1024px o TopNav mostra
// as abas; abaixo disso ele fica só com a marca e o chip de conexão, e quem
// navega é a BottomNav. Não existe mais barra lateral nem hambúrguer — era o
// hambúrguer que sumia em notebook com escala de 125% e deixava o cliente sem
// caminho nenhum.

export default function LayoutMain({ children }) {
  const { logout } = useContext(AuthContext)
  const { isLoading, getCredentials, suspensaoOficial, linkRecarga } = useContext(ApiDataWrapperContext)
  const { api, secret } = getCredentials()
  const theme = useTheme()

  const [notifications, setNotifications] = useState([])

  useEffect(() => {
    // A busca mora dentro do efeito porque só ele a usa — fora daqui o React
    // reclamava de dependência faltando a cada render.
    const buscarNotificacoes = async () => {
      try {
        const notifications = await hipersendService.notificacoesInteligentes.getNotifications()
        setNotifications(notifications)
      } catch (error) {
        console.error(error)

        if(error?.response?.data?.error === 'Não foi possível encontrar a instância') {
          logout()
        }
      }
    }

    buscarNotificacoes()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if(!api || !secret) {
    return (
      <div
        className="h-full w-full flex justify-center items-center"
        style={{ backgroundColor: theme.palette.background.main }}
      >
        <Logo tamanho="grande" assinatura />
      </div>
    )
  }

  const notificacoesAtivas = notifications.filter(notification => notification.isActive)

  return (
    <>
      <NewVersionAppModal />
      <div
        className="relative min-h-full flex flex-col"
        style={{ backgroundColor: theme.palette.background.main }}
      >
        <TopNav />

        {/* A linha de carregamento acompanha o topo, colada logo abaixo dele. */}
        <div className="sticky top-[60px] z-[850]">
          <Collapse in={isLoading} timeout="auto" unmountOnExit>
            <LinearProgressCustom />
          </Collapse>
        </div>

        {/* O respiro embaixo existe só onde a barra inferior existe: acima de
            1024px ela não é renderizada e o espaço sobraria à toa. */}
        <div
          className="w-full flex-1 pb-[var(--respiro-barra)] lg:pb-0"
          style={{ '--respiro-barra': `${ALTURA_BARRA_INFERIOR}px` }}
        >
          {/* WhatsApp oficial suspenso: aparece em qualquer tela, antes de tudo. */}
          <SuspensaoOficialBanner suspensao={suspensaoOficial} linkRecarga={linkRecarga} className="px-4 pt-4 md:px-8" />

          <Collapse in={notificacoesAtivas.length > 0} timeout="auto" unmountOnExit>
            {notificacoesAtivas.map((notification, index) => (
              <div key={index} className="p-8 md:p-12 bg-white bg-opacity-[0.1] rounded-sm">
                <div className="flex space-x-4">
                  <AnnouncementIcon style={{ fontSize: 35 }} className="scale-x-[-1]" />
                  <div>
                    <Text className="font-black text-xl">{notification.title}</Text>
                    <Text>{notification.content}</Text>
                  </div>
                </div>
              </div>
            ))}
          </Collapse>

          {children}
        </div>

        <BottomNav />
      </div>
    </>
  )
}
